export enum StatusEnum {
  confirm = 1,
  unconfirmed = 0,
  all = ''
}
export enum GroupEnum {
  up10 = 101,
  down10 = 102,
  up50 = 100
}

export type Stock = {
  holdDate?: string;
  stockName: string;
  holdPrice: string;
  profitAndLossPrice: string;
  type?: string;
};
export type OrderPic = {
  id: number;
  url: string;
};

export type StockOrder = {
  id: number;
  openId: string;
  orderId: string;
  nickname: string;
  gameName: string;
  totalAssets: number;
  stockPercent: number;
  todayProfitLoss: number;
  groupType: string;
  todayEarningRate: number;
  totalEarningRate: number;
  isTrueIdentify: number;
  holdStockVos: Stock[];
  orderPicVos: OrderPic[];
  checkStatus: StatusEnum;
};
